import React, { Component, useState, useEffect, useContext } from 'react'

import { connect } from 'react-redux'
import { Route, Link, withRouter, BrowserRouter as Router, Switch } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import useMediaQuery from '@material-ui/core/useMediaQuery'

import { login, logout, getCompanies, setActiveCompany } from '../../store/alpha'
import { withAppBase } from '../../AppBase'

import MainBar from '../../shared/ui/MainBar'
import Panel from '../../shared/ui/Panel'
import Button from '../../shared/ui/Button'

import NavigationController from '../../shared/ui/NavigationController'

import BrowseController from './controllers/BrowseController'
import CourseDetailController from './controllers/CourseDetailController'
import CompanyController from './controllers/CompanyController'
import ProviderDetailController from './controllers/ProviderDetailController'
import TrainerDetailController from './controllers/TrainerDetailController'
import PageController from './controllers/PageController'

import { Box, Typography } from '@material-ui/core'

const styles = theme => ({
  root: {
    marginBottom: theme.spacing(10)
  },
  panelAccess: {
    maxWidth: 720,
    margin: '16px auto'
  }
})

const App = ({ params, theme, classes, history, business, login, logout, user, loadingStatus, companies, setActiveCompany }) => {
  
  if (user.isLoggedIn) {
    if (!user.companyInfo && companies && companies.length > 0) {
      setActiveCompany(companies[0].uid)
      return (
        <div className={classes.root}>
          Please select a company
        </div>
        )
    }
  }
  
  const openLink = (url) => {
    history.push(url)
  }
  
  let menuItems = [
      { title: "Browse", linkTo: "/", matchAlso: ["/browse", "/course", "/provider", "/trainer"] },
//      { title: "Solutions", linkTo: "/page/application" }, 
    ]  
    
  let rightMenuItems = []
  
  if (user.isLoggedIn && user.companyInfo)
    menuItems.push({ title: "My Company", linkTo: "/company" })
    
  if (!user.isLoggedIn) {
    // Show link to Training Provider
    rightMenuItems.push({ title: "Become a Trainer", href: "https://trainer.sandbox.pasartrainer.com" })    
  }
    
  const mainBar = <MainBar menuItems={menuItems} rightMenuItems={rightMenuItems} />
      
  const renderBrowseController = (view) => (props) => {
    return <BrowseController view={view} {...props} />
  }

  const noAccessCompany = 
    <Box mt={2} className={classes.panelAccess}>
      <Panel>
        <Box>
          <Typography variant='h6'>Sorry, you have no access to this menu.</Typography>
        </Box>
        <Box mt={2}>
          { user.isLoggedIn ?
            <Button fullWidth variant='contained' color='default' onClick={logout}>
              Logout
            </Button>
            :
            <Button fullWidth variant='contained' color='default' onClick={() => openLink('/')}>
              Browse
            </Button>
          }
        </Box>
      </Panel>
    </Box>

  const renderCompanyView = (props) => {
    if (user.isLoggedIn && user.companyInfo)
      return <CompanyController {...props} />
    else
      return noAccessCompany
  }

  return (
    <NavigationController
      openLink={openLink}
      topBar={mainBar}
      >
      <div className={classes.root}>
        <Switch>
          <Route path="/browse/public-classes" 
            render={renderBrowseController('public-classes')}
            />
          <Route path="/browse/courses"
            render={renderBrowseController('courses')}          
            />          
          <Route path="/browse/providers"
            render={renderBrowseController('providers')}
            />                  
          <Route path="/browse/:categoryKey/public-classes" 
            render={renderBrowseController('public-classes')}
            />
          <Route path="/browse/:categoryKey/courses"
            render={renderBrowseController('courses')}          
            />          
          <Route path="/browse/:categoryKey/providers"
            render={renderBrowseController('providers')}
            />          
          <Route path="/browse/:categoryKey" component={BrowseController} />
          <Route path="/browse" component={BrowseController} />
          <Route path="/course/:courseKey" component={CourseDetailController} />
          <Route path="/provider/:providerKey" component={ProviderDetailController} />
          <Route path="/trainer/:trainerKey" component={TrainerDetailController} />          

          { user.isLoggedIn && user.companyInfo &&
            <Route path="/company" component={CompanyController} />
          }

          <Route exact path="/page" component={PageController} />
          <Route path="/page/:pageKey" component={PageController} />

          <Route exact path="/" component={BrowseController} />          
        </Switch>
      </div>
    </NavigationController>      
    )  
}

const mapStateToProps = (state, ownProps) => {
  let urlParams = new URLSearchParams(ownProps.location.search)

  return {
    params: urlParams,
    companies: getCompanies(state),    
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  let callbackUrl = window.location.href
  
  return {
    login: () => { dispatch(login(callbackUrl)) },
    logout: () => { dispatch(logout(callbackUrl)) },
    setActiveCompany: (company) => { dispatch(setActiveCompany(company)) }    
  }
}

export default withAppBase(
  withRouter(
    withStyles(styles, { withTheme: true })(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(App)
    )
  ),
)
